module.exports = __webpack_public_path__ + "static/media/project-deepmaps.e15c7d25.jpg";